import MultipleCounter from '../MultipleCounter.vue'
import config from '../config'
import { toArray } from '../colors'
import { valueAsNumber, trans } from '../dataFilter'
import Counter from '../config/Counter.vue'
import api from '../api'

export default {
  id: 'counter',
  label: 'Compteur',
  component: MultipleCounter,
  dimensions: 0,
  multipleMeasure: () => true,
  hideExport: true,
  adaptater: (data, vue) => {
    const props = {
      alwaysRound: config.counterAlwaysRound,
      formatters: vue.measure.map(m => vue.buildMeasureFormatter(api.measure.uniqueName(m)))
    }
    if (vue.colorScheme) {
      const colors = toArray(vue.colorScheme)
      props.backgroundColor = colors[0]
      props.color = colors[colors.length - 1]
    }
    vue.buildProps(props)
    return vue.measure.map(m => {
      return {
        value: valueAsNumber(data[0][api.measure.name(m)]),
        label: trans(api.measure.name(m), props.trans)
      }
    })
  },
  config: Counter
}



// WEBPACK FOOTER //
// ./node_modules/macarons-graphs-front/src/graph/Counter.js